<template>
  <div id="programme-otj-guidance" >
    <div class="panel panel-default">
      <section class="panel-body">
        <h2>What is Off-the-Job (OTJ) Training?</h2>
        <p>
          Off-the-Job training (OTJ) is structured learning that takes place during working hours but outside of normal day-to-day job tasks.
          This training should help develop new knowledge, skills, and behaviours (KSBs) relevant to your apprenticeship.
        </p>
      </section>
      <section class="panel-body">
        <h2>How do I log my OTJ training?</h2>
        <p>Follow these steps to correctly record your OTJ training:</p>
        <ol>
          <li>Enter Training Details
            <ul>
              <li>Date: Select the date the training took place.</li>
              <li>Start & End Time: Record the duration of the activity. The system will automatically calculate the total time spent.</li>
              <li>Learning Activity Type: Choose the most relevant type from the dropdown list (e.g., E-learning, Workshop, Mentoring).</li>
            </ul>
          </li>
          <li>Describe Your Learning
            <ul>
              <li>In the comments section, answer the following question:</li>
              <li>What have you learned that you didn’t know before undertaking this activity?</li>
              <li>Provide a brief but clear summary of key takeaways from the session.</li>
            </ul>
          </li>
          <li>Select Relevant Competencies (KSBs)
            <ul>
              <li>Use the table to select one or more competencies (Knowledge, Skills, and Behaviours) you developed during this training by checking the boxes.</li>
              <li>Selected competencies will appear below the table.</li>
            </ul>
          </li>
          <li>Confirm Compliance
            <ul>
              <li>Tick the checkbox to confirm that the training took place during paid working hours and is directly relevant to your apprenticeship.</li>
            </ul>
          </li>
          <li>Save & Submit
            <ul>
            <li>Save as Draft if you need to return and edit later.</li>
              <li>Submit for Review once you are ready for your coach to verify your entry.</li>
            </ul>
          </li>
        </ol>
      </section>
      <section class="panel-footer">
        <div class="panel-footer-column-1">
          <h2>Examples of OTJ Training Activities</h2>
          <ul class="examples-list">
            <li><b>E-learning Modules</b>
              <ul>
                <li>Completing an online course on data analysis.</li>
              </ul>
            </li>
            <li><b>Workplace/KSB Development</b>
              <ul>
                <li>Participating in training sessions or shadowing a senior colleague to develop job-specific skills.</li>
              </ul>
            </li>
            <li><b>Workshop Delivery</b>
              <ul>
                <li>Engaging in practical sessions or hands-on training to build competency in a new tool or methodology.</li>
              </ul>
            </li>
            <li><b>Added Value E-learning</b>
              <ul>
                <li>Undertaking self-paced learning through research, video tutorials, or interactive simulations.</li>
              </ul>
            </li>
            <li><b>EPA Project Work and Support</b>
              <ul>
                <li>Conducting research, preparing documentation, or compiling evidence for End-Point Assessment (EPA).</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="panel-footer-column-2">
          <h2>Best Practices for Accurate Logging</h2>
          <ul class="best-practices-list">
            <li><i class="fa-solid fa-check" aria-hidden="true"></i>Log OTJ activities as soon as possible after completion.</li>
            <li><i class="fa-solid fa-check" aria-hidden="true"></i>Ensure your entries are detailed yet concise.</li>
            <li><i class="fa-solid fa-check" aria-hidden="true"></i>Choose competencies that best reflect what you have learned.</li>
            <li><i class="fa-solid fa-check" aria-hidden="true"></i>Avoid logging regular day-to-day job tasks as OTJ.</li>
          </ul>
          <p>By following this guidance, you’ll ensure your apprenticeship progress is accurately recorded and aligned with learning outcomes.<br>
            If you have any questions, reach out to your mentor or training provider!</p>
        </div>

      </section>
    </div>
  </div>
</template>

<style scoped>
.best-practices-list {
  list-style: none;
}

.best-practices-list li i {
  padding-right: 10px;
  margin-left: -20px;
  color: var(--kate-type-success);
}

.examples-list b {
  font-family: hk-grotesk-semibold, sans-serif;
  color: var(--kate-type-light);
}

.examples-list li ul {
  list-style: none;
  padding-left: 0;
}

.panel-footer-column-1,
.panel-footer-column-2 {
  max-width: 42vw;
}

.panel-footer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}
</style>
